import React, { useEffect, useState } from "react"
import { Box, Button, Checkbox, Container, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import CustomInput from "../../../../components/CustomInput";
import styles from "./style";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
// import { useForm } from "../../../../hooks/useForm";
// import { AddNewRecruitment } from "../../../../constants/data";
// import { ValidationAddRecruitment } from "../../../../helper/Validation";
import dayjs from "dayjs";
import color from "../../../../constants/color";
import { useNavigate } from "react-router-dom";
// import dayjs from "dayjs";
import { LoadingButton } from "@mui/lab";


function CreateRecruitmentPage({ handleAddRecruitment, data, from, updateRecruitment, loading }) {
  const [fromDate, setFromDate] = useState(dayjs(data?.fromDate) || dayjs());
  const [toDate, setToDate] = useState(dayjs(data?.toDate) || dayjs());
  const [position, setPosition] = useState(data?.position || "");
  const [company, setCompany] = useState(data?.company || "")
  const [quantity, setQuantity] = useState(data?.quantity || "")
  const [workingFrom, setWorkingFrom] = useState(data?.type || "")
  const [department, setDepartment] = useState(data?.department || "")
  const [workplace, setWorkplace] = useState(data?.workplace || "")
  const [displaySalary, setDisplaySalary] = useState(data?.displaySalary || "")
  const [startingSalaryFrom, setStartingSalaryFrom] = useState(data?.salaryStart || "")
  const [startingSalaryTo, setStartingSalaryTo] = useState(data?.salaryEnd || "")
  const [reason, setReason] = useState(data?.reason || "")
  const [desc, setDesc] = useState(data?.desc || "")
  const [disable, setDisable] = useState(true);
  useEffect(() => {
    if (data) {
      setFromDate(dayjs(data.fromDate));
      setToDate(dayjs(data.toDate));
      setPosition(data.position || "");
      setCompany(data.company || "");
      setQuantity(data.quantity || "");
      setWorkingFrom(data.type || "");
      setDepartment(data.department || "");
      setWorkplace(data.workplace || "");
      setDisplaySalary(data.displaySalary || false);
      setStartingSalaryFrom(data.salaryStart || "");
      setStartingSalaryTo(data.salaryEnd || "");
      setReason(data.reason || "");
      setDesc(data.desc || "");
    }
  }, [data]);
  const handleRecruitment = (e) => {
    e.preventDefault();
    if (from === "Edit") {
      updateRecruitment(position, company, quantity, department, workplace, displaySalary, startingSalaryFrom, startingSalaryTo, reason, desc, fromDate, toDate, workingFrom)
    } else {
      handleAddRecruitment(position, company, quantity, department, workplace, displaySalary, startingSalaryFrom, startingSalaryTo, reason, desc, fromDate, toDate, workingFrom)
    }
  }
  const navigate = useNavigate();
  const handleNavigateBack = () => {
    navigate("/dashboard/recruitment")
  }
  return (
    <Box sx={{ pl: 2 }}>
      <form onSubmit={(e) => { handleRecruitment(e) }}>
        <Typography sx={styles.headTitle} variant="h4">New Campaign</Typography>
        <Grid container>
          <Grid item lg={8} sm={12}>
            <Box display="flex" flexDirection="row" alignItems="center" ml="2%" mt="2%" mb="2%">
              <Box sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}></Box>
              <Typography sx={styles.subTitle} >General details</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Container maxWidth="md">
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>

                      <InputLabel sx={styles.inputText}>Job Position</InputLabel>
                      <FormControl fullWidth sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.5em",
                          my: "0.5em",
                          borderRadius: "10px"
                        }
                      }} >
                        <Select
                          sx={styles.dropDownMenu}
                          value={position}
                          onChange={(e) => { setPosition(e.target.value); setDisable(false) }}
                          name="position"
                          // onFocus={handleFocus}
                          error={""}
                        >
                          <MenuItem sx={styles.dropDownMenu} value="Developer">Developer</MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Accountant">Accountant</MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Employee">Employee</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>


                      <InputLabel sx={styles.inputText}>Company</InputLabel>
                      <FormControl fullWidth sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.5em",
                          marginTop: "0.5em",
                          borderRadius: "10px"
                        }
                      }} >
                        <Select
                          sx={styles.dropDownMenu}
                          value={company}
                          onChange={(e) => { setCompany(e.target.value); setDisable(false) }}
                          name="company"
                          // onFocus={handleFocus}
                          error={""}
                        >
                          <MenuItem sx={styles.dropDownMenu} value="Cablinks">Cablinks</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={styles.inputText}>Recruited Quantity</InputLabel>
                      <CustomInput
                        name="quantity"
                        type="Number"
                        defaultValue={quantity}
                        value={quantity}
                        onChange={(name, value) => { setQuantity(value); setDisable(false) }}
                        // onFocus={handleFocus}
                        error={""}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={styles.inputText}>Working From</InputLabel>
                      <FormControl fullWidth sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.5em",
                          marginTop: "0.5em",
                          borderRadius: "10px"
                        }
                      }} >

                        <Select
                          value={workingFrom}
                          onChange={(e) => { setWorkingFrom(e.target.value); setDisable(false) }}
                          name="workingFrom"
                          sx={styles.dropDownMenu}
                        // error={workingFrom.error}
                        >
                          <MenuItem sx={styles.dropDownMenu} value="Home">Home</MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Office">Office</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>

                      <InputLabel sx={styles.inputText}>Department</InputLabel>
                      <FormControl fullWidth sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.5em",
                          marginTop: "0.5em",
                          borderRadius: "10px"
                        }
                      }} >
                        <Select
                          value={department}
                          onChange={(e) => { setDepartment(e.target.value); setDisable(false) }}
                          name="department"
                          sx={styles.dropDownMenu}
                        // error={department.error}
                        >
                          <MenuItem sx={styles.dropDownMenu} value="IT">IT</MenuItem>
                          <MenuItem sx={styles.dropDownMenu} value="Accounts">Accounts</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={styles.inputText}>Workplace</InputLabel>
                      <CustomInput
                        //   label="Password"
                        name="workplace"
                        type="text"
                        defaultValue={workplace}
                        value={workplace}
                        onChange={(name, value) => { setWorkplace(value); setDisable(false) }}
                        // onFocus={handleFocus}
                        error={""}

                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={styles.inputText}>Starting Salary From</InputLabel>
                      <CustomInput
                        //   label="Password"
                        name="startingSalaryFrom"
                        type="Number"
                        value={startingSalaryFrom}
                        defaultValue={startingSalaryFrom}
                        onChange={(name, value) => { setStartingSalaryFrom(value); setDisable(false) }}
                        // onFocus={handleFocus}
                        error={""}

                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputLabel sx={styles.inputText}>Starting Salary To</InputLabel>
                      <CustomInput
                        //   label="Password"
                        name="startingSalaryTo"
                        type="Number"
                        defaultValue={startingSalaryTo}
                        value={startingSalaryTo}
                        onChange={(name, value) => { setStartingSalaryTo(value); setDisable(false) }}
                        // onFocus={handleFocus}
                        error={""}

                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel sx={{ borderColor: color.primary, "& .css-1ismtrt-MuiTypography-root ": { fontSize: "12px", fontWeight: "400" } }} control={<Checkbox checked={displaySalary} onChange={(e) => setDisplaySalary(e.target.checked)} />} label="Display salary on the recruitment portal" />


                    </Grid>

                    <Grid item xs={12} sx={{ overflow: "hidden" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} >
                        <DemoContainer components={["DatePicker", "DatePicker"]} sx={styles.calender}>
                          <Grid container spacing={2} sx={{ overflow: "hidden" }}>
                            <Grid item xs={12} sm={6} >

                              <InputLabel sx={styles.inputText}>From</InputLabel>
                              <DatePicker value={fromDate} sx={{ ...styles.calenderInput, width: "100%" }} onChange={(newValue) => { setFromDate(newValue); setDisable(false) }} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <InputLabel sx={styles.inputText}>To</InputLabel>
                              <DatePicker
                                value={toDate}
                                minDate={fromDate}

                                sx={{ ...styles.calenderInput, width: "100%" }}
                                onChange={(newValue) => { setToDate(newValue); setDisable(false) }}
                              />
                            </Grid>
                          </Grid>
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid>

                  </Grid>
                </Container>
              </Grid>
            </Grid>


          </Grid>
          <Grid item xs={12} lg={8}>

            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Container maxWidth="md">
                  <Grid container spacing={1}>
                    <Grid item xs={12} >
                      <InputLabel sx={styles.inputText}>Reason for Recruitment</InputLabel>
                      <CustomInput
                        //   label="Password"
                        defaultValue={reason}
                        name="reason"
                        type="text"
                        value={reason}
                        onChange={(name, value) => { setReason(value); setDisable(false) }}
                        // onFocus={handleFocus}
                        error={""}

                      />
                    </Grid>

                    <Grid item xs={12} >
                      <InputLabel sx={styles.inputText}>Job Description</InputLabel>
                      <CustomInput
                        //   label="Password"
                        name="desc"
                        type="text"
                        value={desc}
                        defaultValue={desc}
                        onChange={(name, value) => { setDesc(value); setDisable(false) }}
                        // onFocus={handleFocus}
                        error={""}
                        multiline
                      />
                    </Grid>
                  </Grid>
                </Container>
              </Grid>
            </Grid>


          </Grid>
        </Grid>
        <Box pb="5%">
          <LoadingButton loading={loading} variant="contained" disabled={from === "Edit" ? disable : !workingFrom || !workplace || !company | !position || !desc || !quantity || !department || !startingSalaryFrom || !startingSalaryTo || !toDate || !fromDate} type="submit" color="success" sx={styles.btn} >
            {from === "Edit" ? "Update" : "Create New"}
          </LoadingButton>
          <Button variant="contained" color="success" sx={{ borderRadius: 50, backgroundColor: "#878787", ml: 2, textTransform: "none", }} onClick={() => handleNavigateBack()}>
            Cancel
          </Button>
        </Box>
      </form>
    </Box>
  )
}

export default CreateRecruitmentPage;